import { useTranslation } from "react-i18next";
import Modal from "./Modal";
import { useNavigate } from "react-router";

function ModalPsaReminder({ close }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSignNow = () => {
    close();
    navigate("/settings/productServiceAgreement");
  };

  return (
    <Modal close={close} title={t("common.psaReminder.title", "Sign your Product Service Agreement")} show={true} size="small">
      <div className="dme-reminder-content">
        <div className="reminder-icon mb-20">
          <i className="material-symbols-outlined">gavel</i>
        </div>

        <p className="mb-20">
          {t(
            "common.psaReminder.message",
            "Your manufacturer requires an electronic Product Service Agreement on file before orders can ship. Signing takes about a minute."
          )}
        </p>

        <ul className="reminder-benefits mb-20">
          <li>{t("common.psaReminder.benefit1", "Activates your DME ordering capability")}</li>
          <li>{t("common.psaReminder.benefit2", "Recorded with a timestamp and audit trail for compliance")}</li>
          <li>{t("common.psaReminder.benefit3", "You can review the full contract before signing")}</li>
        </ul>
      </div>

      <div className="modal-actions btn-bar">
        <button className="btn btn-secondary" onClick={close}>
          {t("common.psaReminder.later", "Later")}
        </button>
        <button className="btn btn-primary" onClick={handleSignNow}>
          {t("common.psaReminder.signNow", "Sign now")}
        </button>
      </div>
    </Modal>
  );
}

export default ModalPsaReminder;
